import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  const scrollToAudit = () => {
    document.getElementById("audit")?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#050505]">
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
          <div className="md:col-span-2">
            <h3 className="font-heading text-3xl md:text-5xl font-bold tracking-tighter max-w-2xl">
              Ready to see what AI is worth to your revenue line?
            </h3>
            <p className="mt-5 text-white/55 max-w-xl">
              Take the 5-minute audit. No sales pitch, no spam, just a clear
              scorecard you can take into your next leadership meeting.
            </p>
          </div>
          <div className="flex md:justify-end">
            <button
              data-testid="footer-cta"
              onClick={scrollToAudit}
              className="group inline-flex items-center gap-2 bg-[#00E5FF] text-black font-medium hover:bg-[#00B8CC] transition-colors px-8 py-4 uppercase tracking-widest text-sm"
            >
              Get my scorecard
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </button>
          </div>
        </div>

        <div className="divider my-16" />

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 text-sm text-white/40">
          <div className="flex items-center gap-3 font-heading">
            <img
              src="https://customer-assets.emergentagent.com/job_landing-lab-16/artifacts/bypk4f2i_New%20logo%201.jpg"
              alt="Peak One Partners"
              className="h-8 w-8 object-cover rounded-sm"
            />
            <span className="text-white/80">Peak One Partners</span>
          </div>
          <div className="font-mono uppercase tracking-widest text-xs">
            © {new Date().getFullYear()}, All rights reserved
          </div>
        </div>
      </div>
    </footer>
  );
}
